import { useResolutionProvider } from 'shared/providers/ResolutionProvider';

// TODO: Move this to context rather than duplicating local state each time this is used -> useResolutionProvider()
const useIsMobile = (): { isMobile: boolean; isTablet: boolean; isDesktop: boolean } => {
  const { isMobile, isTablet } = useResolutionProvider();
  const isDesktop = !isMobile && !isTablet;
  return { isMobile, isTablet, isDesktop };
};

export default useIsMobile;
